import React, { memo, useEffect, useState } from 'react';
import moment from 'moment';
import Calendar from 'react-calendar';
import { DatePicker as CustomDatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/pt_BR';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from 'react-icons/md';
import "./styles.scss"

const dateFormat = 'DD/MM/YYYY';

const formatPeriodDate = (valueToFormat) => {
  let date = []

  const startDate = valueToFormat?.split("|")[0]
  const endDate = valueToFormat?.split("|")[1]

  if (startDate) {
    date.push(moment(startDate).format(dateFormat))
  }

  if (endDate) {
    date.push(moment(endDate).format(dateFormat))
  }

  return date
}

const { RangePicker } = CustomDatePicker;

export const CalendarDatePicker = ({ setCurrentDateOnClick, calendarRef }) => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    setCurrentDateOnClick && setCurrentDateOnClick(date)
  }, [date])

  const onChange = (value) => {
    setDate(value)
    calendarRef.current.getApi().gotoDate(new Date(value))
  }
  return (
    <Calendar prevLabel={<MdOutlineArrowBackIosNew />} nextLabel={<MdOutlineArrowForwardIos />} onChange={onChange} value={date} />
  );
}

export const PickerType = ({
  placeholder = ["Data inicial", "Data final"],
  onChange,
  className,
  defaultValue,
  value,
  type,
  isWhite = true,
}) => {
  const variante = isWhite ? "custom-select-antd" : "custom-select-input-normal";

  if (type === 'year') {
    return (
      <CustomDatePicker
        picker={type}
        format={defaultValue}
        defaultValue={defaultValue}
        className={`${variante} ${className} antd-only-date`}
        onChange={(date, dateString) => onChange(dateString, date)}
        placeholder="Selecione o ano"
      />
    );
  } else if (type === 'month') {
    return (
      <CustomDatePicker
        picker={type}
        defaultValue={defaultValue}
        className={`${variante} ${className} antd-only-date`}
        onChange={(date, dateString) => onChange(dateString, date)}
        placeholder="Selecione o mês"
      />
    );
  }

  return (
    <RangePicker
      value={
        value && [
          dayjs(formatPeriodDate(value)[0], dateFormat, 'pt-br'),
          dayjs(formatPeriodDate(value)[1], dateFormat, 'pt-br'),
        ]
      }
      defaultValue={
        defaultValue && [
          dayjs(formatPeriodDate(defaultValue)[0], dateFormat, 'pt-br'),
          dayjs(formatPeriodDate(defaultValue)[1], dateFormat, 'pt-br'),
        ]
      }
      onChange={(value) =>
        typeof onChange === 'function' &&
        onChange(
          value
            ? `${moment(value[0]['$d']).format('YYYY-MM-DD')}|${moment(value[1]['$d']).format('YYYY-MM-DD')}`
            : null
        )
      }
      format={dateFormat}
      className={`${variante} ${className} antd-only-date`}
      locale={locale}
      placeholder={placeholder}
    />
  );
};

export const PickerWithType = memo(({ placeholder, onChange, className, defaultValue, value, type, isWhite }) => (
  <PickerType
    placeholder={placeholder}
    onChange={onChange}
    className={className}
    defaultValue={defaultValue}
    value={value}
    type={type}
    isWhite={isWhite}
  />
));

export const DatePicker = ({ onChange, className, defaultValue, value, isWhite, placeholder = "Selecione a data", ...field }) => {
  const variante = isWhite ? "custom-select-antd" : "custom-select-input-normal"

  return (
    <CustomDatePicker
      value={value && dayjs(value, dateFormat, 'pt-br')}
      format={dateFormat}
      defaultValue={defaultValue && dayjs(defaultValue, dateFormat, 'pt-br')}
      className={`${variante} ${className} antd-only-date`}
      onChange={(date, dateString) => onChange(dateString, date)}
      placeholder={placeholder}
      locale={locale}
      {...field}
    />
  )
}